import React from 'react';
import { Footer, Header, Section } from '../../../bound/landingPage';
import { Wrapper } from '../../../bound/landingPage/Wrapper';
import {
    SanitySubmenuSectionProps,
    Submenu,
} from '../../../bound/landingPage/Submenu';
import { Sections } from '../../../bound/landingPage/Sections';
import {
    LandingPageCTAQueryParamContext,
    SanityObject,
    SanitySlug,
} from '../../../lib/landingPage';

type LpQueryParam = { param: string; value: string };

export type PageProps = {
    sections: SanityObject<Section>[];
    slug: SanitySlug;
    pageTitle?: string;
    metaDescription?: string;
    hideMenu?: boolean;
    hideButtons?: boolean;
    disableLogoLink?: boolean;
    ctaQueryParams?: LpQueryParam[];
};

const mergeParams = (
    ctaQueryParams?: LpQueryParam[]
): Record<string, string> | undefined =>
    ctaQueryParams
        ? Object.fromEntries(
              ctaQueryParams.map(({ param, value }) => [param, value])
          )
        : undefined;

export const Page = Wrapper(
    ({
        sections,
        slug,
        hideMenu,
        hideButtons,
        disableLogoLink,
        ctaQueryParams,
    }: PageProps): JSX.Element => {
        const submenuSection = sections.filter(s => s._type === 'submenu');
        const mergedParams = mergeParams(ctaQueryParams);

        return (
            <LandingPageCTAQueryParamContext.Provider value={mergedParams}>
                <div>
                    <Header
                        hideMenu={hideMenu}
                        hideButtons={hideButtons}
                        disableLogoLink={disableLogoLink}
                    />
                    {submenuSection.length > 0 && (
                        <Submenu
                            slug={slug}
                            submenu={
                                submenuSection[0] as unknown as SanitySubmenuSectionProps
                            }
                        />
                    )}
                    <Sections sections={sections} slug={slug} />
                    <Footer hideMenu={false} />
                </div>
            </LandingPageCTAQueryParamContext.Provider>
        );
    },
    'page'
);
